import React from "react";
import "./login.module.css";

import ImagePartitionLayout from "../../layout/imagepartitionlayout/imagepartitionlayout";
import LoginForm from "./components/loginform";
import AuthenticationContainer from "../../components/AuthenticationContainer/authenticationcontainer";
import moment from 'moment-timezone'
import get from 'lodash/get'
import {LOGIN_SUBTITLE, WEBSITE_TITLE} from "../../constants/appconstants";
class Login extends React.Component {

  render() {

    return (
      <ImagePartitionLayout ContentComponent={ <AuthenticationContainer  Component={<LoginForm/>} titleLabel={"Welcome"}/>}
                            title={WEBSITE_TITLE}
                            subtitle={
                              ""}
      />
    );
  }
}

export default Login;



